export default "__VITE_ASSET__nSmJ1co$__"